<template>
	<aside v-if="isLogged">
		<!-- ADMIN MENU -->
		<ul class="menu" v-if="role == 'admin'">
			<router-link tag="li" :to="{ name : 'admin.dashboard'}"><a><img src="./../../assets/images/icons/solid/home.svg" />Homepage</a></router-link>			

			<!-- LHCSA MENU -->
			<li class="has-submenu" :class="{ 'active' : toggle_status['organization'] }">
				<a @click="toggle('organization')">
					<img src="./../../assets/images/icons/solid/building.svg" />Agencies</a>
				<ul data-title="Agencies">
					<li><router-link tag="a" :to="{ name : 'admin.organizations.index' }">View all</router-link></li>
					<li><router-link tag="a" :to="{ name : 'admin.organizations.create' }">Create</router-link></li>
				</ul>
			</li>

			<!-- HHA MENU -->
			<li class="has-submenu" :class="{ 'active' : toggle_status['hha'] }">
				<a @click="toggle('hha')">
					<img src="./../../assets/images/icons/solid/user-graduate.svg" />Employees</a>
				<ul data-title="HHAs">
					<li><router-link tag="a" :to="{ name : 'admin.providers.index' }">View all</router-link></li>
					<li><router-link tag="a" :to="{ name : 'admin.providers.create' }">Create</router-link></li>
				</ul>
			</li>

			<!-- SME MENU -->
			<li class="has-submenu" :class="{ 'active' : toggle_status['sme'] }">
				<a @click="toggle('sme')"><img src="./../../assets/images/icons/solid/chalkboard-teacher.svg" />SMEs</a>
				<ul data-title="SMEs">
					<li><router-link tag="a" :to="{ name : 'admin.smes.index' }">View all</router-link></li>
					<li><router-link tag="a" :to="{ name : 'admin.smes.create' }">Create</router-link></li>
				</ul>
			</li>

			<!-- COURSES MENU -->
			<li class="has-submenu" :class="{ 'active' : toggle_status['courses'] }">
				<a @click="toggle('courses')"><img src="./../../assets/images/icons/solid/th-large.svg" />Programs</a>
				<ul data-title="Programs">
					<li><router-link tag="a" :to="{ name : 'admin.courses.index' }">View all</router-link></li>
					<li><router-link tag="a" :to="{ name : 'admin.courses.create' }">Create</router-link></li>
				</ul>
			</li>

			<!-- CATEGORIES MENU -->
			<li class="has-submenu" :class="{ 'active' : toggle_status['categories'] }">
				<a @click="toggle('categories')"><img src="./../../assets/images/icons/solid/tags.svg" />Categories</a>
				<ul data-title="Categories">
					<li><router-link tag="a" :to="{ name : 'admin.categories.index' }">View all</router-link></li>
					<li><router-link tag="a" :to="{ name : 'admin.categories.create' }">Create</router-link></li>
				</ul>
			</li>

			<li class="has-submenu" :class="{ 'active' : toggle_status['categories'] }">
				<a @click="toggle('categories')"><img src="./../../assets/images/icons/solid/wrench.svg" />Configs</a>
				<ul data-title="Configs">
					<li><router-link tag="a" :to="{ name : 'admin.configs.entities-taggables.index' }">Tag management</router-link></li>
					<li><router-link tag="a" :to="{ name : 'admin.notification-management.index' }">Notification management</router-link></li>
					<li><router-link tag="a" :to="{ name : 'admin.terms.index' }">Terms</router-link></li>
					<li><router-link tag="a" :to="{ name : 'admin.faq.index' }">FAQs</router-link></li>
				</ul>
			</li>
			
			<li @click="logout()"><a><img src="./../../assets/images/icons/solid/sign-out-alt.svg" />Logout</a></li>
		</ul>

		<!-- LHCSA MENU -->
		<ul v-if="role == 'organization'" class="menu">
			<router-link tag="li" v-if="user_meta_actions.includes('list_provider')" :to="{ name : 'organization.providers.index' }"><a><img src="./../../assets/images/icons/solid/home.svg" />Homepage</a></router-link>
			
			<!-- <router-link tag="li" :to="{ name : 'organization.providers.index' }"><a><img src="./../../assets/images/icons/solid/user-graduate.svg" />Employees</a></router-link>  -->
			<router-link tag="li" :to="{ name : 'organization.courses.index' }"><a><img src="./../../assets/images/icons/solid/th-large.svg" />Programs</a></router-link>
			<router-link tag="li" :to="{ name : 'organization.reports.index' }"><a><img src="./../../assets/images/icons/solid/clipboard-list.svg" />Reports</a></router-link>
			<li @click="logout()"><a><img src="./../../assets/images/icons/solid/sign-out-alt.svg" />Logout</a></li>
		</ul>

		<!-- SME MENU -->
		<ul v-if="role == 'sme'" class="menu">
			<!-- <router-link tag="li" :to="{ name : 'sme.dashboard'}"><a><img src="./../../assets/images/icons/solid/home.svg" />Homepage</a></router-link> -->
			<li :class="{ 'active' : toggle_status['courses'] }">
				<router-link  :to="{ name : 'sme.dashboard', params:{section : 'Programs'} }"><a><img src="./../../assets/images/icons/solid/th-large.svg" />Programs</a></router-link>
				<router-link  :to="{ name : 'sme.dashboard', params:{section : 'Modules'} }"><a><img src="./../../assets/images/icons/solid/chalkboard-teacher.svg" />Modules</a></router-link>
				<router-link  :to="{ name : 'sme.dashboard', params:{section : 'Lessons'} }"><a><img src="./../../assets/images/icons/solid/building.svg" />Lessons</a></router-link>
				<router-link  :to="{ name : 'sme.dashboard', params:{section : 'Languages'} }"><a><img src="./../../assets/images/icons/solid/user-graduate.svg" />Languages</a></router-link>
				<router-link  :to="{ name : 'sme.dashboard', params:{section : 'Categories'} }"><a><img src="./../../assets/images/icons/solid/clipboard-list.svg" />Categories</a></router-link>
			</li>
			<li @click="logout()"><a><img src="./../../assets/images/icons/solid/sign-out-alt.svg" />Logout</a></li>
		</ul>

		<!-- CustomerSuccessTeam -->
		<ul v-if="role == 'csm'" class="menu">
			<!-- <router-link tag="li" :to="{ name : 'csm.dashboard'}"><a><img src="./../../assets/images/icons/solid/home.svg" />Homepage</a></router-link> -->
		
			<router-link  tag="li" :to="{ name : 'csm.providers.index' }"><a v-if="user_meta_actions.includes('list_provider')"><img src="./../../assets/images/icons/solid/user-graduate.svg" />Organization Providers</a></router-link> 
			<!-- <router-link tag="li" :to="{ name : 'organization.courses.index' }"><a><img src="./../../assets/images/icons/solid/th-large.svg" />Programs</a></router-link> -->
			<router-link tag="li" :to="{ name : 'csm.organizations.index'}"><a><img src="./../../assets/images/icons/solid/building.svg" />Agencies</a></router-link>
			 <router-link tag="li"  :to="{ name : 'csm.plain_providers' }"><a v-if="user_meta_actions.includes('list_provider')"><img src="./../../assets/images/icons/solid/chalkboard-teacher.svg" />Providers</a></router-link>
			 <router-link tag="li" :to="{ name : 'shopify.dashboard' }"><a><img src="./../../assets/images/icons/solid/cart-plus.svg" />Shopify</a></router-link>
			
			<li @click="logout()"><a><img src="./../../assets/images/icons/solid/sign-out-alt.svg" />Logout</a></li>
		</ul>
	</aside>
</template>


<script>
export default{
	data : function() {
		return  {
			toggle_status : [],
			user_meta_actions: localStorage.getItem('meta_actions')
		}
	},

	created : function(){

	},
	computed : {
		isLogged : function(){
			return this.$store.getters.isLogged;
		},
		role : function() {
			return this.$store.getters.getRole;
		}
	},

	methods : {
		logout : function(){
			this.$store.dispatch('logout', { router : this.$router });
		},
		toggle : function(menu_option){
			this.$set(this.toggle_status, menu_option, !this.toggle_status[menu_option]);
		}
	}
}

</script>


// WEBPACK FOOTER //
// src/components/shared/AsideComponent.vue